/**
 * Per-locale plural rules, shared by the app and the test harness so component
 * tests render exactly what a player sees.
 *
 * Only locales whose rule differs from vue-i18n's default need an entry. The
 * default treats 0 as plural, which is right for English, German, Spanish and
 * Italian, and the CJK catalogs carry a single invariant form that renders at
 * every count.
 */
export type PluralRule = (choice: number, choicesLength: number) => number

/** French counts 0 with the singular: "0 titre", not "0 titres". */
const french: PluralRule = (choice, choicesLength) => {
  if (choicesLength < 2) return 0
  return Math.abs(choice) <= 1 ? 0 : 1
}

export const PLURAL_RULES: Record<string, PluralRule> = { fr: french }
